import React from "react";

export function SettingsPage() {
  return (
    <div className="admin-page">
      <header className="admin-page-header">
        <h1>Settings</h1>
      </header>
      <div className="admin-page-content">
        <p className="admin-muted">Admin settings. User profile and preferences are managed in the main app.</p>
      </div>
    </div>
  );
}
